import { render, staticRenderFns } from "./KioskSettings.vue?vue&type=template&id=461956d9&"
import script from "./KioskSettings.vue?vue&type=script&lang=js&"
export * from "./KioskSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports